import type {SVGProps} from 'react'
const PlayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    preserveAspectRatio="none"
    width="1em"
    height="1em"
    overflow="visible"
    style={{
      display: 'block',
    }}
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      id="Outline"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1.00159C0 0.218078 0.860162 -0.261083 1.52635 0.151321L10.5764 5.75375C11.208 6.14469 11.208 7.06333 10.5764 7.45428L1.52635 13.0567C0.860165 13.4691 0 12.9899 0 12.2064V1.00159ZM10.0501 6.60401L1 1.00159V12.2064L10.0501 6.60401Z"
      fill="var(--fill-0, #2D2E2C)"
    />
  </svg>
)
export {PlayIcon}
